import $ from 'jquery'

export default function installFormHelper() {
  $.fn.serializeHash = function() {
    const hash = {}
    for (const pair of Array.from(this.serializeArray())) {
      hash[pair.name] = pair.value
    }
    return hash
  }

  $.fn.validatePresenceOf = function(fieldName) {
    const field = this.find(`[name=${fieldName}]`)
    if (/^ *$/.test(field.val())) {
      field.addErrorMessage('Please enter a value')
      return false
    } else {
      field.removeErrorMessage()
      return true
    }
  }

  $.fn.validateEquals = function(fieldName, value, message) {
    if (message == null) {
      message = ''
    }
    const field = this.find(`[name=${fieldName}]`)
    if (field.val() !== value) {
      field.addErrorMessage(message)
      return false
    } else {
      field.removeErrorMessage()
      return true
    }
  }

  $.fn.validateEmailAddress = function(fieldName) {
    const field = this.find(`[name=${fieldName}]`)
    return /\S+@\S+\.\S+/.test(field.val())
  }

  $.fn.addErrorMessage = function(errorMessage) {
    this.closest('.form-group').addClass('has-error')
    const inlineHelp = this.siblings('.help-block')
    if (inlineHelp.length === 0) {
      $('<span>')
        .addClass('help-block')
        .text(errorMessage)
        .insertAfter(this)
    }
  }

  $.fn.removeErrorMessage = function() {
    this.closest('.form-group').removeClass('has-error')
    return this.siblings('.help-block').remove()
  }

  $.fn.removeAllErrors = function() {
    this.find('.help-block').remove()
    return this.find('.form-group.has-error').removeClass('has-error')
  }
}
